import { Button, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { useInvoiceContext } from 'src/shared/contexts/invoiceContext';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useState } from 'react';
import { AddCircle } from '@mui/icons-material';
import { useGlobals } from 'src/shared/contexts/appContext';
import { AutogiroMandateCreateFilesModal } from '../components/autogiroMandateCreateFilesModal';
import { AutogiroMandateCreateModal } from '../components/autogiroMandateCreateModal';

export const AutogiroPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setDateStamp } = useGlobals();
  const location = useLocation();
  const isAutogiroPage = location.pathname === RoutesEnum.Autogiro;
  const { createFileMode, selectedAutogiroMandates, setCreateFileMode, setSelectedAutogiroMandates } = useInvoiceContext();
  const [showCreateAutogiroMandateModal, setShowCreateAutogiroMandateModal] = useState<boolean>();

  const pageTabs: PageTabItem[] = [
    {
      label: 'invoice:autogiro.tabAutogiro',
      route: RoutesEnum.Autogiro,
    },
    // {
    //   label: 'invoice:autogiro.tabCreateFile',
    //   route: RoutesEnum.AutogiroCreateFile,
    // },
    {
      label: 'invoice:autogiro.tabMemberautogirostatus',
      route: RoutesEnum.Memberautogirostatus,
    },
  ];

  const onSaveHandler = () => {
    setCreateFileMode(false);
    setSelectedAutogiroMandates([]);
    navigate(RoutesEnum.Autogiro);
  };

  return (
    <>
      <GridWrapper>
        <Grid item xs>
          <MainContentHeader title={t('invoice:autogiroOverviewPage.pageTitle')} />
        </Grid>
        {isAutogiroPage && (
          <Grid item xs='auto'>
            <Button
              onClick={() => setShowCreateAutogiroMandateModal(true)}
              variant='contained'
              color='secondary'
              startIcon={<AddCircle />}
              disableElevation
            >
              {t('invoice:autogiroOverviewPage.createAutogiroMandateButton')}
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Paper>
            <PageTabNavigation pageTabs={pageTabs} />
            <Outlet />
          </Paper>
        </Grid>
      </GridWrapper>
      {createFileMode && selectedAutogiroMandates && !!selectedAutogiroMandates.length && (
        <AutogiroMandateCreateFilesModal
          mandates={selectedAutogiroMandates}
          modalOpen={selectedAutogiroMandates && !!selectedAutogiroMandates.length}
          onClose={() => {
            setCreateFileMode(false);
            setSelectedAutogiroMandates([]);
          }}
          onSave={onSaveHandler}
        />
      )}
      {showCreateAutogiroMandateModal && (
        <AutogiroMandateCreateModal
          modalOpen={showCreateAutogiroMandateModal}
          onClose={() => {
            setShowCreateAutogiroMandateModal(false);
          }}
          onSave={() => {
            setShowCreateAutogiroMandateModal(false);
            setDateStamp(new Date());
          }}
        />
      )}
    </>
  );
};
